export default __webpack_public_path__ + "static/media/new-close.d487f91d.svg";